import DatabaseModel from './DatabaseModel.js';
import unwrapDto from './responseUtils.js';

var Ayuda = Object.create(DatabaseModel);
Ayuda.model = 'ayudas';
Ayuda.modelFront = 'ayudas';

// Caché de resolución por pantalla. El icono de ayuda resuelve en cada navegación, así que sin
// caché sería una petición por cambio de página. La invalida el formulario al guardar.
Ayuda._cacheResolver = {};

// Todo lo cacheado caduca. invalidarCache() sólo corre en el navegador que edita, así que sin
// caducidad las demás sesiones abiertas seguirían enseñando una ayuda borrada, desactivada o vieja
// hasta que alguien recargase. Los negativos caducan antes porque el caso "acabo de crear la ayuda
// y no sale" es el que más despista.
var TTL_SIN_AYUDA = 30000;
var TTL_CON_AYUDA = 300000;

/**
 * Devuelve la ayuda de una pantalla, o null si no tiene.
 * @param {{clave?: string, ruta?: string}} params
 */
Ayuda.resolver = function (params) {
    var self = this;
    params = params || {};
    var qs = [];
    if (params.clave) qs.push('clave=' + encodeURIComponent(params.clave));
    if (params.ruta) qs.push('ruta=' + encodeURIComponent(params.ruta));
    if (!qs.length) return Promise.resolve(null);

    var cacheKey = qs.join('&');
    var enCache = self._cacheResolver[cacheKey];
    if (enCache && Date.now() - enCache.ts < (enCache.ayuda ? TTL_CON_AYUDA : TTL_SIN_AYUDA)) {
        return Promise.resolve(enCache.ayuda);
    }

    var request = {
        url: self.server_movilidad + self.prefix + self.model + '/resolver?' + cacheKey,
        method: 'GET',
        data: {}
    };
    return self.sendRequest(request, false).then(function (res) {
        var ayuda = unwrapDto(res) || null;
        self._cacheResolver[cacheKey] = { ayuda: ayuda, ts: Date.now() };
        return ayuda;
    });
};

/** Tras editar una ayuda hay que olvidar lo resuelto para que el icono cargue la versión nueva. */
Ayuda.invalidarCache = function () {
    this._cacheResolver = {};
};

export default Ayuda;
